<!-- Without a link, routerLink renders no href and ignores clicks. -->
<a
  [routerLink]="homeLink()"
  [class]="homeLink() ? 'hover:bg-white/10' : 'cursor-default'"
  [pTooltip]="homeLink() ? 'Home' : ''"
  [showDelay]="TOOLTIP_DEFAULT_DELAY"
  (click)="onLogoClick()"
  class="flex items-center justify-center size-7 rounded-lg transition-colors duration-header ease-header"
  tooltipPosition="bottom"
  data-testid="flowx-logo-btn"
  aria-label="Home"
>
  <img
    class="size-[22px]"
    alt="FlowX"
    src="./assets/logo-white.svg"
  />
</a>

@if (area() === 'org') {
  @if (goBackWorkspaceName(); as workspaceName) {
    <button
      (click)="goBack()"
      class="flx-ds small ternary neutral whitespace-nowrap"
      flxButton
      icon="left"
      type="button"
      data-testid="go-back-button"
    >
      <i
        class="ph ph-arrow-left"
        flxIcon
      ></i>
      Back to
      <!-- Its tooltip shows only while the name is cut. -->
      <span
        [showDelay]="TOOLTIP_DEFAULT_DELAY"
        class="max-w-header-name truncate text-white"
        pTooltip="{{ workspaceName }}"
        tooltipPosition="bottom"
        showOnEllipsis
        >{{ workspaceName }}</span
      >
    </button>
    <hr class="w-px h-4 mx-1 shrink-0 border-0 bg-white/[0.18]" />
  }
  <!-- After the divider, padded like Go back's label, so the space on both sides of it matches. -->
  <span
    [class.pl-2]="goBackWorkspaceName()"
    class="flex items-center gap-2"
    data-testid="organization-name"
  >
    <i class="ph ph-buildings text-base text-neutral-500"></i>
    {{ organizationCode || 'Organization settings' }}
  </span>
}
